import * as React from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

import logoImage from '../assets/cmcos_logo_white.png';
import { changeHeaderColorByEnv } from '../../constants/Colors';
import { headerHeight, spHeaderHeight } from '../../constants/Location';

const styles = {
  header: {
    bgcolor: changeHeaderColorByEnv(),
    width: '100%'
  },
  headerTitle: {
    '@media screen and (max-width:600px)': {
      minHeight: spHeaderHeight
    },
    flexGrow: 1,
    fontSize: '23px',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-between',
    mr: '12px',
    ml: '12px',
    minHeight: headerHeight
  },
  headerWrapper: {
    flexGrow: 1,
    position: 'sticky',
    top: 0,
    zIndex: 10
  },
  logoImage: {
    width: '80px'
  }
};

export default function Header(): React.ReactElement {
  return (
    <>
      <Box sx={styles.headerWrapper}>
        <AppBar position="fixed" sx={styles.header} elevation={0}>
          <Toolbar sx={styles.headerTitle}>
            <img src={logoImage} style={styles.logoImage} />
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
}
